module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-pragmatic-play.35b9e38c.png";